import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Title = styled.div`
  margin-bottom: ${layout.measurements.spacingNormal};
  h2 {
    font-size: ${layout.measurements.fontSizeNormal};
    font-weight: 600;
    margin-bottom: 0;
  }
`;

export const Body = styled.div`
  margin-bottom: ${layout.measurements.spacingNormal};

  .pj-ui-text-input {
    margin-bottom: 0;
  }

  p {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: flex-end;
  justify-content: flex-end;
  width: 100%;
  button {
    white-space: nowrap;
    margin-left: ${layout.measurements.spacingSmall};
    flex: 1;
    &:first-child {
      margin-left: 0;
    }
  }
`;
